module.exports = __webpack_public_path__ + "static/media/AW_HP_FR_766x844_Lemonade.7e6cd4d9.mp4";